import { ToastDurations } from '../../../shared/toast/useToast/Toast';
import { ToastAppearance } from './ToastProvider/ToastAppearance';
import { ToastProvider } from './ToastProvider/ToastProvider';

/**
 * The root provider of the three logged-in apps.
 *
 * No theme or reset: those are plain CSS (`@repo/features/appTailwind.css` and
 * Tailwind's reset) imported by each root layout.
 *
 * It is only `ToastProvider` today, kept as a wrapper so the next app-wide
 * provider has one place to go.
 */
export const AppProvider = ({
  children,
  toastDurations,
  toastAppearance,
}: {
  children: React.ReactNode;
  toastDurations?: ToastDurations;
  toastAppearance?: ToastAppearance;
}) => {
  return (
    <ToastProvider durations={toastDurations} appearance={toastAppearance}>
      {children}
    </ToastProvider>
  );
};
